import * as Redux from 'redux'
import * as DateSelector from '../../components/date-selector'
import * as Sortable from '../../components/sortable'
import * as Request from '../../request'
import * as Constants from './constants'
import * as Types from './types'

const emptyViewState: Types.FeedbackViewState = {
  isLoading: false,
  selectedDate: null,
  sort: [],
}

type AllActions = Redux.Action & Request.SuccessAction & DateSelector.DatedInformationAction & Sortable.SortAction

export const viewReducer = (sourceReducer: any) =>
  (state: Types.FeedbackViewState = emptyViewState, action: AllActions) => {
  const sourceState = sourceReducer(state, action)
  switch (action.type) {
    case Request.requestConstant(Constants.FETCH_FEEDBACK):
      return {
        ...sourceState,
        selectedDate: action.options.payload.selectedDate,
      }
    default:
      return sourceState
  }
}

const reducerEvent: Sortable.ReducerEvent<Types.NewsbriefFeedback> = {
  defaultSort: {field: 'id', dir: 'desc'},
  requestEvent: Constants.FETCH_FEEDBACK,
}

export const reducer = Redux.combineReducers({
  data: Sortable.stateReducer(reducerEvent),
  view: viewReducer(Sortable.viewReducer(reducerEvent)),
})



// WEBPACK FOOTER //
// ./src/pages/feedback/reducer.ts